import { motion } from 'framer-motion';

const steps = [
  {
    num: '01',
    title: 'Consultation',
    desc: 'We align on scope, programme, and budget so expectations are clear from day one.',
  },
  {
    num: '02',
    title: 'Site survey',
    desc: 'Accurate measurements and site conditions captured before design is locked.',
  },
  {
    num: '03',
    title: 'Design & planning',
    desc: 'Drawings, detailing, and fabrication planning tailored to your structure.',
  },
  {
    num: '04',
    title: 'Fabrication',
    desc: 'Cutting, fitting, and certified welding completed in our workshop.',
  },
  {
    num: '05',
    title: 'Installation / delivery',
    desc: 'Coordinated delivery and safe installation — or supply-only when you need it.',
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

const stepVariants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1] } },
};

export default function Process() {
  return (
    <section className="process" id="process">
      <div className="container">
        <div className="process-header">
          <motion.div
            className="eyebrow"
            style={{ justifyContent: 'center' }}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            How we work
          </motion.div>
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.08 }}
          >
            Our process
          </motion.h2>
          <motion.p
            className="section-sub"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.14 }}
          >
            A straightforward path from first conversation to steel on site — with
            proactive updates at every milestone.
          </motion.p>
        </div>

        <motion.div
          className="process-track"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-60px' }}
        >
          {steps.map((step) => (
            <motion.div key={step.num} className="process-step" variants={stepVariants}>
              <div className="step-hex">
                <span className="step-hex-num">{step.num}</span>
              </div>
              <div className="step-title">{step.title}</div>
              <p className="step-desc">{step.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
